<mat-card>
  <app-card-header
    [title]="title()"
    icono="science"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <form [formGroup]="form()!" autocomplete="off">
      <!-- Tracker ID (disabled) -->
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Tracker ID</mat-label>
        <input matInput formControlName="trackerId" readonly />
        <mat-icon matPrefix>gps_fixed</mat-icon>
      </mat-form-field>

      <!-- Duración en horas -->
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Duración (horas)</mat-label>
        <input
          matInput
          type="number"
          formControlName="durationHours"
          step="0.1"
          min="0.1"
        />
        <mat-icon matPrefix>schedule</mat-icon>
        <mat-hint>
          Por cuánto tiempo reportará (ej: 1.5 = 1 hora y 30 minutos)
        </mat-hint>
        @if (form()?.get('durationHours')?.hasError('required')) {
          <mat-error>Campo requerido</mat-error>
        }
        @if (form()?.get('durationHours')?.hasError('min')) {
          <mat-error>Mínimo 0.1 horas</mat-error>
        }
      </mat-form-field>

      <!-- Velocidad en km/h -->
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Velocidad (km/h)</mat-label>
        <input
          matInput
          type="number"
          formControlName="speedKmh"
          min="1"
          max="200"
        />
        <mat-icon matPrefix>speed</mat-icon>
        <mat-hint>
          Velocidad a la que se moverá el tracker (afecta frecuencia de
          reportes)
        </mat-hint>
        @if (form()?.get('speedKmh')?.hasError('required')) {
          <mat-error>Campo requerido</mat-error>
        }
        @if (form()?.get('speedKmh')?.hasError('min')) {
          <mat-error>Mínimo 1 km/h</mat-error>
        }
        @if (form()?.get('speedKmh')?.hasError('max')) {
          <mat-error>Máximo 200 km/h</mat-error>
        }
      </mat-form-field>

      <!-- Selector de recorrido -->
      <div style="padding-top: 10px">
        <ng-select
          [fixedPlaceholder]="true"
          formControlName="recorrido"
          [items]="recorridos()"
          bindLabel="nombre"
          placeholder="Seleccioná un recorrido"
          [notFoundText]="'No hay recorridos disponibles'"
          style="width: 100%"
          multiple="false"
          searchable="true"
          appendTo="body"
        >
          <ng-template ng-option-tmp let-item="item">
            <div>
              <mat-icon style="vertical-align: middle; margin-right: 8px">
                route
              </mat-icon>
              <span>{{ item.nombre }}</span>
            </div>
          </ng-template>
        </ng-select>
        @if (
          form()?.get('recorrido')?.invalid && form()?.get('recorrido')?.touched
        ) {
          <mat-error style="margin-top: 8px; display: block">
            Debe seleccionar un recorrido
          </mat-error>
        }
      </div>

      <!-- Información -->
      @if (form()?.get('recorrido')?.value) {
        <div class="info-message">
          <mat-icon>check_circle</mat-icon>
          <span>
            Recorrido seleccionado:
            {{ form()?.get('recorrido')?.value?.nombre }}
          </span>
        </div>
      } @else {
        <div class="info-message">
          <mat-icon>info</mat-icon>
          <span>
            Seleccioná un recorrido para que el tracker simule el movimiento a
            lo largo de la ruta.
          </span>
        </div>
      }
    </form>
  </mat-card-content>

  <!-- Botones -->
  <mat-card-actions class="actions-create">
    <app-button
      matType="mat-fab extended"
      color="neutral"
      (click)="cerrar()"
      text="Cancelar"
      icon="close"
      [disabled]="loading()"
    ></app-button>
    <app-button
      matType="mat-fab extended"
      color="primary"
      text="{{ loading() ? 'Iniciando...' : 'Iniciar Simulación' }}"
      icon="{{ loading() ? '' : 'play_arrow' }}"
      type="submit"
      [disabled]="!form()?.valid || loading()"
      (click)="onSubmit()"
    ></app-button>
  </mat-card-actions>
</mat-card>
